<template>
  <div
    v-if="!isAppointmentEnded"
    class="mx-auto px-4 py-1.5"
    :data-timestamp="event.timestamp"
  >
    <div class="flex flex-col items-center rounded-8 bg-bg-base-bg4 shadow-raised px-4 py-3 w-fit mx-auto">
      <p class="text-body-r-14-20 text-fg-base-fg10 text-center">
        {{ timeRange }}
        {{ $t('chat.groupCallStarted') }}
      </p>
      <p
        v-if="displayAppointmentName"
        class="text-heading-sb-14-20 text-fg-base-fg10 text-center"
        data-test="appointment-name"
      >
        «{{ displayAppointmentName }}»
      </p>
    </div>
    <div
      v-if="isUnread"
      class="relative"
    >
      <span class="absolute right-[-10px] bottom-0 h-2 w-2 rounded-full bg-primary-tints-400" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  HistoryMessageItem,
  MessageCallReceived,
  MessageCallAppointmentStart,
} from '@wui/im'
import { computed } from 'vue'

import { chatModel, useUnreadMessages } from '@/entities/messages'

import { useLocalization } from '@/shared/composables/localization'

import { getAppointmentEventDisplayName, getAppointmentTimeRangeText } from '../'

const props = defineProps<{
  event: HistoryMessageItem<MessageCallAppointmentStart>,
}>()

const { findRoomMessages } = chatModel.useChatMessageStore()
const { t } = useLocalization()

const events = computed(() => findRoomMessages(props.event.item.pServed))
const timeRange = computed(() => getAppointmentTimeRangeText(props.event))
const displayAppointmentName = computed(() => (
  getAppointmentEventDisplayName(props.event.item.appointmentName, t('common.withoutTitle'))
))

const isAppointmentEnded = computed(() => {
  return !!events.value.find(e => (e.item as MessageCallReceived)?.event === 'appointment_end'
    && (e.item as MessageCallAppointmentStart).confId === props.event.item.confId)
})

const { isUnread } = useUnreadMessages(props.event)
</script>
